import NProgress from 'nprogress'

export default function(resources) {
    return {
        data() {
            let initData = {}
            for (const key in resources) {
                initData[key] = null
            }
            this.resources = resources;
            return initData;
        },
        methods: {
            async fetchData(key, url, scroll = false, reload = false) {
                if (reload) {
                    try {
                        this.$data[key] = await this.$fetch(url)
                    } catch (e) {
                        this.showErrorMessage('loading', e.toString());
                    }
                    if (window.riTimeout) {
                        clearTimeout(window.riTimeout);
                        window.riTimeout = setTimeout(() => { this.fetchData(key, url, scroll, reload) }, 10000)
                    } else {
                        window.riTimeout = setTimeout(() => { this.fetchData(key, url, scroll, reload) }, 10000)
                    }
                    var element = document.getElementById("last_update");
                    if (element !== null) {
                        element.innerHTML = new Date().toLocaleTimeString();
                    }
                } else {
                    try {
                        this.showLoading(scroll);
                        this.$data[key] = await this.$fetch(url)
                    } catch (e) {
                        this.showErrorMessage('loading', e.toString());
                    } finally {
                        this.hideLoading();
                    }
                }
            },
            showErrorMessage(alert_message = '-1', full_alert_message = '', icon = 'report_problem') {
                this.$store.state.alert = {
                    alert: true,
                    alert_message: (alert_message+''),
                    full_alert_message: full_alert_message,
                    icon: icon,
                    closeable: true,
                    color: 'red'
                }
            },
            showSuccessMessage(alert_message = 'loading', full_alert_message = '', icon = 'done_all') {
                this.$store.state.alert = {
                    alert: true,
                    alert_message: (alert_message+''),
                    full_alert_message: full_alert_message,
                    icon: icon,
                    closeable: false,
                    color: "green"
                }
            },
            showInfoMessage(alert_message = 'loading', full_alert_message = '', icon = 'help') {
                this.$store.state.alert = {
                    alert: true,
                    alert_message: (alert_message+''),
                    full_alert_message: full_alert_message,
                    icon: icon,
                    closeable: true,
                    color: "blue"
                }
            },
            showTicket(ticket_info, ticket_message = '', ticket_summary = '') {
                this.$store.state.ticket = {
                    ticket: true,
                    ticket_message: ticket_message,
                    ticket_summary: ticket_summary,
                    ticket_info: ticket_info
                }
            },
            hideTicket() {
                this.$store.state.ticket = {
                    ticket: false
                }
            },
            hideMessage() {
                this.$store.state.alert = {
                    alert: false
                }
            },
            showLoading(scroll = false) {
                const html = document.getElementsByTagName("html")[0];
                if (scroll) {
                    //html.scrollTop = 0;
                }
                html.classList.add("no-scroll");
                this.$store.state.loading = true;
                NProgress.start();
            },
            hideLoading() {
                NProgress.done();
                this.$store.state.loading = false;
                const html = document.getElementsByTagName("html")[0];
                html.classList.remove("no-scroll");
            }
        },
        created() {
            for (const key in resources) {
                let url = resources[key]
                if (typeof(url) === "function") {
                    this.$watch(url, (val) => {
                        if (Array.isArray(val)) {
                            this.fetchData(key, val[0], false, val[1])
                        } else {
                            this.fetchData(key, val)
                        }
                    }, {
                        immediate: true
                    })
                } else {
                    this.fetchData(key, url)
                }
            }
        }
    }
}